import React, { Component } from "react";
import { Modal } from "antd";
import FeedbackModalRender from "./children/FeedbackModalRender";
import { requestFeedback, requestFeedbackUpload } from "../../../../../../api/apis";
import i18n from "../../../../../../../../locales/i18n";
import { GAPersonalFeedbackConfirmStatus } from "../../../../../../ga/personalCenter";

export default class FeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      problemTypeList: [
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeSug"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeMem"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeFun"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeReq"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeBug"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeIss"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeRL"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeRef"),
        },
        {
          value: i18n.t("personalCenterSetting:feedBackModalProductTypeOth"),
        },
      ],
      uploading: false, //上传中的状态
      uploadFileObj: null, //上传的文件参数
      submitting: false, //正在提交的状态
    };
    this.forgetFormRef = React.createRef(); // 忘记密码表单ref
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  /**
   * 点击提交feedback 按钮
   * @param {object} data 表单数据
   */
  handleSubmitFeedback = data => {
    this.setState({
      submitting: true,
    });
    if (this.state.uploadFileObj) {
      data.log_id = JSON.stringify(this.state.uploadFileObj);
    }
    this.handleRequsetFeedback(data);
  };

  /**
   *请求修改密码
   * @param {object} data 表单数据
   */
  handleRequsetFeedback = data => {
    let formData = new FormData();
    formData.append("product_id", "4011");
    formData.append("version", "1.7.0");
    formData.append("system", navigator.userAgent);
    formData.append("useremail", this.props.email);
    formData.append("subject", data.problem);
    formData.append("content", data.content);
    formData.append("log_id", data.log_id);
    requestFeedback({
      body: formData,
    })
      .then(res => {
        this.props.handleVisible(false);
        if (res.status === 200) {
          GAPersonalFeedbackConfirmStatus("success");
          this.props.handleChangeResultObj({
            visible: true,
            title: i18n.t("personalCenterSetting:feedBackSuccessTips"),
            subTitle: i18n.t("personalCenterSetting:feedBackSuccessSubTips"),
            status: "success",
            width: 460,
          });
        } else {
          GAPersonalFeedbackConfirmStatus("failed");
          this.props.handleChangeResultObj({
            visible: true,
            title: i18n.t("personalCenterSetting:feedBackFailedTips"),
            subTitle: i18n.t("personalCenterSetting:feedBackFailedSubTips"),
            status: "failed",
            width: 460,
          });
        }
      })
      .catch(err => {
        GAPersonalFeedbackConfirmStatus("failed");
        console.log(err);
      })
      .finally(() => {
        this.setState({
          submitting: false,
        });
      });
  };

  /**
   *删除上传的文件
   */
  handleDeleteFile = () => {
    this.setState({
      uploadFileObj: null,
    });
  };

  /**
   * 监听上传文件组件
   * @param {object} { file } 上传组件监听到的上传文件 File 格式
   */
  handelUploadFile = file => {
    this.setState({
      uploading: true,
    });
    let formData = new FormData();
    formData.append("file", file);
    formData.append("folder", "ticket");
    formData.append("useremail", "1043231196@qq.com");
    formData.append("product_id", "4011");
    formData.append("version", "1.7.0");
    requestFeedbackUpload({
      body: formData,
    })
      .then(res => {
        console.log(res);
        if (res.status === 200) {
          this.setState({
            uploadFileObj: {
              ...res.body,
            },
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          uploading: false,
        });
      });

    //阻止组件默认请求
    return false;
  };

  uploadProps = {
    action: false,
    maxCount: 1,
    showUploadList: false,
    beforeUpload: this.handelUploadFile,
  };

  render() {
    const { visible, handleVisible } = this.props;
    return (
      <Modal
        getContainer={false}
        centered
        maskClosable={false}
        visible={visible}
        title={null}
        footer={null}
        width={660}
        onCancel={() => handleVisible(false)}
      >
        <FeedbackModalRender
          problemTypeList={this.state.problemTypeList}
          email={this.props.email}
          form={this.resetFormRef}
          submitting={this.state.submitting}
          uploading={this.state.uploading}
          handleSubmitFeedback={this.handleSubmitFeedback}
          uploadProps={this.uploadProps}
          uploadFileObj={this.state.uploadFileObj}
          handleDeleteFile={this.handleDeleteFile}
        />
      </Modal>
    );
  }
}
